import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IContentMobile } from "../../../Pages/ContentMobile/IContentMobile";

export const AddContentMobileSlice = createSlice({
  name: "AddContentMobileSlice",
  initialState: {} as IReduxState<IContentMobile>,
  reducers: {
    addContentMobile: (state, _: PayloadAction<IContentMobile>) => {
      state.isLoading = true;
    },
    successaddContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddContentMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addContentMobile,
  failureaddContentMobile,
  successaddContentMobile,
  clearAddContentMobileResponse,
} = AddContentMobileSlice.actions;

export default AddContentMobileSlice.reducer;
